import { render } from "./FormPhotoPart.vue?vue&type=template&id=c5dc1982"
import script from "./FormPhotoPart.vue?vue&type=script&lang=js"
export * from "./FormPhotoPart.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__